import React from 'react';
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import styled from 'styled-components';
import styles from './styles.module.scss'
interface CheckBoxComponentProps {
  onChange: any;
  text: string;
  checked?: boolean
}
const StyledCheckbox = styled(Checkbox)`
margin:8px
`;
const CheckBoxComponent: React.FC<CheckBoxComponentProps> = ({ onChange, text, checked }: CheckBoxComponentProps) => {
  return (
    <StyledCheckbox onChange={onChange} defaultChecked={checked ? true : false}><p className={styles["text"]}>{text}</p></StyledCheckbox>
  )
}

export default CheckBoxComponent;
